import { render, staticRenderFns } from "./Migration.vue?vue&type=template&id=0b7adf2b&"
import script from "./Migration.vue?vue&type=script&lang=js&"
export * from "./Migration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7adf2b')) {
      api.createRecord('0b7adf2b', component.options)
    } else {
      api.reload('0b7adf2b', component.options)
    }
    module.hot.accept("./Migration.vue?vue&type=template&id=0b7adf2b&", function () {
      api.rerender('0b7adf2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/Migration.vue"
export default component.exports